import axios from "axios";

const API = axios.create({
baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/drivers/admin`,
});

// ✅ Upload file
export async function uploadFile(file) {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const res = await API.post("/upload", formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✅ Delete file
export async function deleteFile(publicId) {
  try {
    const res = await API.delete(`/delete/${publicId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    console.log("Delete response:", res.data);
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}